import { h, Component } from 'preact';
import { RootStore } from '../../js/stores/root.store';

type Props = {
  size: number;
  color?: string;
  strokeWidth: number;
  timeToComplete?: number;
  elapsedTime: number;
  clickCloseTime: number;
};

type State = {
  rendered: boolean;
  currentAnimationFrame: number;
  animationDuration?: string;
};

export default class ProgressRing extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      rendered: false,
      currentAnimationFrame: 0
    };
  }

  render() {
    const {
      size,
      color,
      strokeWidth,
      timeToComplete = 0,
      elapsedTime,
      clickCloseTime
    } = this.props;

    const isViewable = RootStore.getInstance().adContainerStore.isViewable
      .value;
    const radius = size / 2 - 2 * strokeWidth;
    const circumference = radius * 2 * Math.PI;

    if (!this.state.currentAnimationFrame) {
      this.setState({ currentAnimationFrame: circumference });
    }

    if (!this.state.animationDuration) {
      this.setState({ animationDuration: `${timeToComplete}s` });
    }

    if (isViewable && !this.state.rendered) {
      this.setState({ rendered: true });
    }

    if (!isViewable && this.state.rendered) {
      const remainingTime = elapsedTime - clickCloseTime;
      this.setState({
        currentAnimationFrame:
          circumference - (circumference * remainingTime) / timeToComplete,
        animationDuration: `${timeToComplete - remainingTime}s`,
        rendered: false
      });
    }

    return isViewable ? (
      <svg width={size} height={size}>
        <style>
          {`@keyframes completeRing {
            from {
              stroke-dashoffset: ${this.state.currentAnimationFrame};
            }

            to {
              stroke-dashoffset: 0;
            }
          }`}
        </style>
        <circle
          stroke={color}
          stroke-width={strokeWidth}
          fill="none"
          r={radius}
          cx={size / 2}
          cy={size / 2}
          style={{
            strokeDasharray: `${circumference}`,
            transform: 'rotate(-90deg)',
            transformOrigin: '50% 50%',
            animationName: 'completeRing',
            animationDuration: this.state.animationDuration,
            animationTimingFunction: 'linear'
          }}
        />
      </svg>
    ) : (
      ''
    );
  }
}

ProgressRing.defaultProps = {
  size: 20,
  color: 'white',
  strokeWidth: 1,
  timeToComplete: 1
};
